import type { FrontendWidget } from '../types';
import {
  BookProjectFormComponent,
  type BookProjectFormResolved,
} from './BookProjectFormComponent';

// Inline widget: the resolved shape is the CMS config, unchanged. The type
// lives next to the component so `index.ts` stays the only importer of it —
// a one-field widget does not need a `types.ts` of its own.
export type BookProjectFormConfig = BookProjectFormResolved;
export type { BookProjectFormResolved };

export const bookProjectFormWidget: FrontendWidget<
  BookProjectFormConfig,
  BookProjectFormResolved
> = {
  componentType: 'widgets.book-project-form',
  displayName: 'Book Project Form',
  // Inline widget: no backend resolver, nothing to look up.
  ComponentA: BookProjectFormComponent,
  resolveSync: (config) => config,
};
